const { useState } = require("react");

const ModalResponseComponent = ({
  comment,
  handleSendComment,
  setIsCommentModalOpen,
  setComment,
}) => {
  const [error, setError] = useState("");
  const [isFormValid, setIsFormValid] = useState(true);

  const sanitizeInput = (input) => {
    return input.replace(/<[^>]*>?/gm, "");
  };

  const validateComment = (input) => {
    const sanitizedInput = sanitizeInput(input);

    if (sanitizedInput.length > 100) {
      setError("Comment cannot exceed 100 characters");
      setIsFormValid(false);
    } else {
      setError("");
      setIsFormValid(true);
    }

    setComment(sanitizedInput);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
      <div className="bg-notificationList p-6 rounded-xl max-w-sm w-full shadow-lg outline oultine-1 outline-secondary">
        <h2 className="text-xl font-bold mb-4">Approve/Reject</h2>
        <label className="block text-sm font-medium mb-1 text-textMuted">
          Message (optional)
        </label>
        <textarea
          onChange={(e) => validateComment(e.target.value)}
          value={comment}
          placeholder="Enter your comment"
          className={`w-full p-2 rounded-lg shadow-md bg-black/30 outline outline-1 text-textMuted ${
            error ? "outline-red-500" : "outline-notificationList"
          }`}
        ></textarea>
        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
        <div className="flex justify-end gap-2 mt-4">
          <button
            onClick={() => setIsCommentModalOpen(false)}
            className="outline outline-1 outline-secondary px-4 py-2 mr-2 rounded-lg text-white hover:bg-secondary"
          >
            Cancel
          </button>
          <button
            onClick={handleSendComment}
            className={`px-4 py-2 rounded-lg text-black ${
              !isFormValid
                ? "outline outline-1 outline-secondary cursor-not-allowed text-white"
                : "bg-accent hover:bg-opacity-80"
            }`}
            disabled={!isFormValid}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalResponseComponent;
